import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PrepaidCard } from 'src/features/subscriptions/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/prepaid-card/';

interface DTO extends ListDTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<PrepaidCard>> => {
    // Custom core filtering
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            (params as Record<string, any>)[key] = value.join(',');
        }
    });

    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useListPrepaidCards };
